export default __webpack_public_path__ + "static/media/warning.f4bfc1de.svg";